export default __webpack_public_path__ + "static/media/pingpong.c9cfcae3.png";